"use client";

import { Button } from "@astryxdesign/core/Button";
import {
  LandingAccountMenu,
  type LandingAccountUser,
} from "@/components/landing/landing-account-menu";
import { LandingPhoneContact } from "@/components/landing/landing-phone-contact";
import {
  styledTextString,
  styledTextStyle,
  type LandingTextValue,
} from "@/lib/landing/puck/styled-text";

type LandingHeaderActionsProps = {
  isLoggedIn?: boolean;
  isReturning?: boolean;
  primaryHref?: string;
  primaryLabel?: LandingTextValue;
  user?: LandingAccountUser | null;
};

export function LandingHeaderActions({
  isLoggedIn = false,
  isReturning = false,
  primaryHref = "/reports/create",
  primaryLabel = "Проверить идею",
  user = null,
}: LandingHeaderActionsProps) {
  return (
    <div className="hidden shrink-0 items-center gap-1 sm:flex sm:gap-1.5">
      <LandingPhoneContact placement="below" compact />
      {isLoggedIn && user ? (
        <LandingAccountMenu user={user} placement="below" />
      ) : (
        <>
          <a href="/login" className="shrink-0">
            <Button label="Войти" variant="secondary" size="sm" />
          </a>
          {!isReturning ? (
            <a href={primaryHref} className="shrink-0">
              <Button
                label={styledTextString(primaryLabel) || "Проверить идею"}
                variant="primary"
                size="sm"
                style={styledTextStyle(primaryLabel)}
              />
            </a>
          ) : null}
        </>
      )}
    </div>
  );
}
